export default __webpack_public_path__ + "static/og-9e6a2fbda2bc50a89715ec16887c453a.png";